import { render, staticRenderFns } from "./VesselManagement.vue?vue&type=template&id=02795f02&scoped=true"
import script from "./VesselManagement.vue?vue&type=script&lang=js"
export * from "./VesselManagement.vue?vue&type=script&lang=js"
import style0 from "./VesselManagement.vue?vue&type=style&index=0&id=02795f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02795f02",
  null
  
)

export default component.exports